import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta04 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-04/utils-consultaSeguimentoPergunta04'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta04 } from './converter-HistoricoMchatPergunta04'

interface HistoricoMChatRfPergunta04Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta04 = (props: Readonly<HistoricoMChatRfPergunta04Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta04(aplicacoes)
  if (converted == null) return null

  const { header, perguntas, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta04(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='4'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta='“Ele gosta de subir em...”'
      />
      <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntas} />
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
